export default __webpack_public_path__ + "static/media/36I-114280_-20488_0.2854cf9f.jpg";